<template>
<div class="container">
    <div class="row mb-3">
        <div class="col-12 mb-4">
            <div class="d-flex align-items-center">
                <div class="mr-2">
                    <BuyersIcon :color="getPrimaryColorHex.four" />
                </div>
                <h3 class="mb-0 ml-1 bold c-ndarkthree">
                    Sacados
                </h3>
            </div>
            <p class="c-ndarkfour mt-2">
                {{ `Visualize ${getWhiteLabel == 'CASHFORCE' ? 'e classifique' : ''} os sacados cadastrados na plataforma`}}
            </p>
        </div>
        <div class="col-12 row align-items-center justify-content-between">
            <TabClassification v-if="getWhiteLabel == 'CASHFORCE'" class="col-6" @tabSelect="activeTab = $event; attFilter($event)" /> 
            <!-- AJUSTAR DIFERENTE DE CASHFORCE AQUI -->
            <TabModelOffer v-else class="col-6" @tabSelect="activeTab = $event; attFilter($event)" />
            <div class="row">
                <SponsorsProviderBuyerFilter
                    :filters="filters"
                    @updateFilter="updateFilter($event); getEconomicGroups()"
                    @empty="updateFilter($event); getEconomicGroups()"
                    v-if="!isCashforce"
                />
                <div class="ml-2">
                    <el-input 
                        @keyup.native.enter="getEconomicGroups" 
                        placeholder="Buscar" 
                        class="filter" 
                        :class="getPrimaryColor" 
                        v-model="filterSearch"
                        @clear="getEconomicGroups"
                        clearable
                    >
                        <button class="btn" slot="append" @click="getEconomicGroups">
                            <Search color="#A1A8B8" class="mx-0" />
                        </button>
                    </el-input>
                </div>
            </div>
        </div>
    </div>
    <TableContainer 
        v-if="loading || economicGroups.length" 
        :isLoading="loading" 
        :pagination="pagination" 
        @updatePage="updatePage($event)"
    >
        <BuyersByEconomicGroup
            v-if="isCashforce"
            :economicGroups="economicGroups"
            @classificationChange="getGroups()"
        />
        <!-- AJUSTAR DIFERENTE DE CASHFORCE AQUI -->
        <BuyersByEconomicGroupAutoOffer
            v-else
            :economicGroups="economicGroups"
            @classificationChange="updateGroups()"

        />
    </TableContainer>
    <NotFound class="pt-5" v-else-if="!loading && filterSearch.length > 0 && economicGroups.length === 0" />
    <EmptyPage :button="false" title="Ainda não há sacados nessa classificação!" v-else-if="!loading && filterSearch.length <= 0 && economicGroups.length === 0">
        Por enquanto, não há sacados nessa classificação.
    </EmptyPage>
</div>
</template>

<script>
// Libraries
import _ from 'lodash'

// Icons
import Search from '@/components/icons/Search'
import BuyersIcon from '@/components/icons/Buyers'

// Table
import BuyersByEconomicGroup from '@/components/tables/BuyersByEconomicGroup'
import TableContainer from '@/components/tables/TableContainer'
import BuyersByEconomicGroupAutoOffer from '../../components/tables/BuyersByEconomicGroupAutoOffer.vue'

// APIs
import getActiveGroupsWithTotalValue from '@/api/getActiveGroupsWithTotalValue'
import getRejectedEconomicGroups from '@/api/getRejectedEconomicGroups'

// Other Components
import TabClassification from '@/components/tabs/TabClassification'
import TabModelOffer from '@/components/tabs/TabModelOffer'
import NotFound from '@/components/emptyOrNotFound/NotFound'
import EmptyPage from '@/components/emptyOrNotFound/EmptyPage'
import SponsorsProviderBuyerFilter from '@/components/filters/SponsorsProviderBuyerFilter.vue'

// Utils
import { FILTERS } from '@/utils/constants';

// Vars
const FILTERS_USED = ['totalValue']

export default {
    components: {
        Search,
        BuyersIcon,
        BuyersByEconomicGroup,
        TabClassification,
        NotFound,
        EmptyPage,
        TableContainer,
        SponsorsProviderBuyerFilter,
        TabModelOffer,
        BuyersByEconomicGroupAutoOffer,
    },
    data() {
        return {
            economicGroups: [],
            rejectedEconomicGroups: [],
            filterSearch: '',
            loading: true,
            activeTab: this.$store.state.tabs.buyersTab,
            pagination: {},
            page: 1,
            filters: _.pick(FILTERS, FILTERS_USED),
        }
    },
    watch: {
        activeTab() {
            this.getEconomicGroups()
        }
    },
    computed: {
        filtersAPI() {
            const { filters, page } = this
            return this.formatFilteredAPIMixin({filters, setPagination: page}) 
        }
    },
    methods: {
        updatePage(page){
            this.page = page
        },
        async getEconomicGroups() {
            this.loading = true
            
            await getActiveGroupsWithTotalValue({
                search: this.filterSearch,
                maxOrderValue: this.filters.totalValue.maxValue,
                minOrderValue: this.filters.totalValue.minValue,
                page: this.page,
                modelOffer: this.activeTab == 2 ? 'manual' :
                            this.activeTab == 1 ? 'automatic' :
                            this.activeTab == 3 ? 'blocked' :
                            null,
                ids: this.activeTab == 1 || this.activeTab == 2 ? this.rejectedEconomicGroups.join(',') : null,
                ...this.filtersAPI,
                bySponsor: true,

            })

            this.pagination = this.$store.state.group.groupsPagination
            this.economicGroups = this.$store.state.group.groups
            
            this.loading = false
            
        },
        async getRejectedEconomicGroups() {
            const rejectedIds = []
            const response = await getRejectedEconomicGroups(this.$store.state.user.cnpjId)

            if (response) {
                response.map((rejectedEconomicGroup) => {
                    rejectedIds.push(rejectedEconomicGroup.economicGroupId)
                })

                return rejectedIds
            }

            return rejectedIds
        },
        updateFilter(filter){
            this.filters = filter
            this.page = 1
        },
        attFilter(event) {
            this.activeTab = event
        },
        async getGroups(){
            this.rejectedEconomicGroups = await this.getRejectedEconomicGroups()
            await this.getEconomicGroups()
        },
        async updateGroups() {
            await this.getEconomicGroups()
        }
    },
    async created () {
        await this.getGroups()
    },
}
</script>
<style lang="scss">
.tooltip-shower {
    width: 72px;
    min-height: 32px;
    margin-left: 0;
    position: absolute;
    top: 7px;
    
    span {
        width: 100%;
        cursor: pointer;
    }
}
</style>